import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SolutionRuleStateService {
  solutionAdditionalProperties$ = new BehaviorSubject<Record<string, any>>(null);
  solutionActions$ = new BehaviorSubject<any[]>([]);

  // Used to update state for a specific key value.  Can leverage multiple decoupled components by storing configuration on different keys.
  UpdateAdditionalPropertyStateForKey(key: string, additionalPropertyStateForKey: any) {
    const newState = { ...(this.solutionAdditionalProperties$.getValue() ?? {}) };
    newState[key] = additionalPropertyStateForKey;
    this.solutionAdditionalProperties$.next(newState);
  }

  // Used to set full custom state
  UpdateAdditionalPropertiesState(additionalPropertiesState: Record<string, any>) {
    this.solutionAdditionalProperties$.next(additionalPropertiesState);
  }

  UpdateActionsState(actionState: any[]) {
    this.solutionActions$.next(actionState);
  }
}
